import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../context/Internationalization";
import { BILLING_ROUTE } from "../routes";
import StartClubTrialButton from "./StartClubTrialButton";
import StatusAlert from "./Common/StatusAlert";
import { buttonVariants } from "../shadcn/components/ui/button";
import {
  billingActionLabel,
  formatBillingDate,
  getBillingPresentation,
} from "../pages/Billing/billingPresentation";

export default function ClubBillingNotice({ billing, onRefreshBilling }) {
  const { t, lang } = useTranslation();
  const canView = billing.canViewBilling === true;
  const presentation = getBillingPresentation(billing, lang);
  const titleKey = presentation.titleKey || "billing_notice_subscription";
  // Staff without billing permission only see their access level, not financial details.
  const messageKey = canView
    ? presentation.messageKey
    : "billing_state_read_only";
  const message = presentation.messageDate
    ? t(messageKey).replace("{date}", presentation.messageDate)
    : t(messageKey);
  const endDate =
    canView && billing.cancelAtPeriodEnd
      ? formatBillingDate(billing.currentPeriodEnd, lang)
      : null;
  const startDate =
    canView && presentation.messageKey === "billing_state_early_signup"
      ? formatBillingDate(billing.freeAccessUntil, lang)
      : null;
  const trialEnd =
    canView && presentation.dateFields.includes("trialEnd")
      ? formatBillingDate(billing.trialEnd, lang)
      : null;

  return (
    <StatusAlert
      severity={presentation.severity}
      role="status"
      aria-label={t(titleKey)}
      title={t(titleKey)}
      className="mx-4 mt-6 w-auto md:mx-6"
      action={
        billing.canManageBilling === true &&
        (billing.canStartLocalTrial || ["checkout", "portal"].includes(billing.nextAction)) ? (
          billing.canStartLocalTrial ? (
            <StartClubTrialButton
              key={String(billing.clubId)}
              clubId={billing.clubId}
              onStarted={onRefreshBilling}
            />
          ) : (
            <Link
              to={BILLING_ROUTE}
              className={buttonVariants({ variant: "outline", size: "sm" })}
            >
              {t(billingActionLabel(billing))}
            </Link>
          )
        ) : null
      }
    >
      {message}
      {endDate && (
        <div>
          {t("current_period_ends")}: {endDate}
        </div>
      )}
      {startDate && (
        <div>
          {t("billing_starts")}: {startDate}
        </div>
      )}
      {trialEnd && (
        <div>
          {t("trial_ends")}: {trialEnd}
        </div>
      )}
      {billing.canManageBilling !== true && (
        <div>{t("billing_contact_administrator")}</div>
      )}
    </StatusAlert>
  );
}
